import { GroupDashboard } from "@/features/data/group-dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/group-dashboard/$groupId")({
  component: GroupDashboard,
});
